import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Dashboard as DashboardIcon } from '@mui/icons-material';
import { useMsal, useAccount } from '@azure/msal-react';
import { MyTicketsCard, MyTeamsTicketsCard, AssignedToMeCard, PendingResponseCard } from './cards';
import NavigationSection from './NavigationSection';

const Dashboard: React.FC = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  return (
    <Box sx={{ p: 3, backgroundColor: '#F4F6F9', minHeight: '100vh' }}>
      {/* Welcome Header */}
      <Paper
        sx={{
          p: 3,
          mb: 3,
          background: 'linear-gradient(135deg, #162346 0%, rgba(22, 35, 70, 0.8) 50%, rgba(22, 35, 70, 0.6) 100%)',
          color: 'white',
          borderRadius: 2,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 50%, rgba(255,255,255,0.05) 100%)',
            pointerEvents: 'none'
          }
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <DashboardIcon sx={{ fontSize: '2rem', opacity: 0.9 }} />
          <Box>
            <Typography variant="h4" fontWeight={600}>
              Welcome to Trackly
            </Typography>
            <Typography variant="h6" sx={{ opacity: 0.8, fontWeight: 400 }}>
              {account?.name ? `Hello, ${account.name.split(' ')[0]}!` : 'Help Desk Dashboard'}
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.7, mt: 1, fontWeight: 300 }}>
              Monitor your tickets, track progress, and manage support requests efficiently
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Metrics Cards */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            lg: 'repeat(4, 1fr)'
          },
          gap: 3,
          mb: 3
        }}
      >
        <MyTicketsCard />
        <MyTeamsTicketsCard />
        <AssignedToMeCard />
        <PendingResponseCard />
      </Box>

      {/* Module Navigation */}
      <NavigationSection />
    </Box>
  );
};

export default Dashboard;